import _ from "lodash";

import { ExternalUser, ExternalUserRole, SalesPerson } from "models/customers/customers";
import { DocumentService, WizardCustomer } from "models/wizard/WizardState";

export type ExternalUserPayload = {
  id: string;
  email: string;
  givenName: string;
  surName: string;
  roles: ExternalUserRole[];
  socialSecurityNumber: string;
  sendInvite?: boolean;
};

export type InternalUserPayload = {
  id: string;
  role: string;
  isVisibleForCustomer: boolean;
};

export type SaveCustomerPayload = {
  id: string;
  isPrivate: boolean;
  fpService: any;
  documentServices: DocumentService[];
  internalUsers: InternalUserPayload[];
  externalUsers: ExternalUserPayload[];
};

export function createInternalUser(user: SalesPerson): InternalUserPayload {
  return {
    id: user.id,
    role: user.role,
    isVisibleForCustomer: user.visibleForCustomer
  };
}

export function createExternalUser(user: ExternalUser): ExternalUserPayload {
  return {
    id: user.id,
    email: user.email,
    givenName: user.givenName,
    surName: user.surName,
    roles: user.roles,
    socialSecurityNumber: user.socialSecurityNumber,
    sendInvite: user.sendInvite
  };
}

export function setUserService(
  service: DocumentService,
  userId: string,
  active: boolean
) {
  const exists = service.userIds.includes(userId);
  if (active && !exists) {
    service.userIds.push(userId);
  } else if (!active && exists) {
    _.remove(service.userIds, (id) => id === userId);
  }
}

export function toggleUserService(
  documentService: DocumentService,
  userId: string
) {
  if (documentService.userIds.includes(userId)) {
    _.remove(documentService.userIds, (id) => id === userId);
  } else {
    documentService.userIds.push(userId);
  }
}

export function setupCustomer(customer: WizardCustomer) {
  return {
    id: customer.id,
    isPrivate: customer.isPrivate,
    isEditing: customer.state === "1",
    state: customer.state, //TODO: Obsolete
    sniCode: customer.sniCode,
    customerName: customer.customerName,
    organizationNumber: customer.organizationNumber,
    contactInformation: customer.contactInformation,
    internalUsers: customer.internalUsers || [], //TODO: Obsolete
    externalUsers: customer.externalUsers,
    documentServices: customer.documentServices || [],
    activeProjectTypes: customer.activeProjectTypes,
    services: customer.services || [],
    customerServices: customer.customerServices || []
  };
}
